<template>
  <div>
    <b-row v-if="operations.length === 0">
      <b-col class="text-center">
        <b-alert show variant="info">
          Compila il modulo di ricerca, clicca Cliente interessato e su Mostra Storico.
        </b-alert>
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col cols="12">
        <b-card>
          <template #header>
            <div style="height: 1.5rem">
              <strong>
                <b-icon-clock-history/>&nbsp;Storico Operazioni</strong>
            </div>
          </template>
          <b-card-body>
            <b-row>
              <b-col align="center">
                <b-list-group-item ><strong>Data operazione</strong></b-list-group-item>
                <b-list-group v-for="item in labels">
                  <b-list-group-item>{{ item }}</b-list-group-item>
                </b-list-group>
              </b-col>

              <b-col align="center" v-for="(operation, index) in operations">
                <b-list-group-item><strong>{{ asItalianFormat(operation['operationDateTime']) }}</strong></b-list-group-item>
                <b-list-group v-for="item in history[index]">
                  <b-list-group-item>{{ item.value }}</b-list-group-item>
                </b-list-group>
                <b-list-group-item>
                  <b-button v-if="operations[index].agreementId !== 'none'" size="sm" :href="`/api/memberships/${operations[index]['agreementId']}/signed_agreement`"
                            target="_blank"
                            v-b-tooltip.hover title="Scarica Adesione">
                    <b-icon-download></b-icon-download>
                  </b-button>
                  <div v-else> Documento non trovato </div>
                </b-list-group-item>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import eventBus from '@/EventBus'
import OperationsWithAgreement from "@/logic/OperationsWithAgreement"
import moment from 'moment';
import Translate from '@/Translate'

export default {
  name: 'History',
  data: () => ({
    shops: null,
    history: [],
    labels: [],
    operations: []
  }),
  mounted() {
    eventBus.$on('customer-selected', this.findOperations)
    eventBus.$on('customers-searched', () => {
      this.operations = []
      this.history = []
    })
  },
  methods: {
    findOperations(customerId) {
      this.columns = []
      OperationsWithAgreement(customerId)
        .then(operations => {
          this.operations = operations.map(this.formatOperation)
          this.labels = this.formatLabels(this.operations[0])
          this.operations.forEach(operation => this.history.push(this.formatHistory(operation)))
          this.formatDuplicate()
          this.removeDuplicate()
        })
    },
    formatHistory(operation) {
      return Object.keys(operation).filter((item => item !== 'operationDateTime' && item !== 'agreementId' && item !== 'changeId')).map(item =>{
        if (item === 'marketingConsensus' || item === 'profilingConsensus' || item === 'cooperativesConsensus' || item === 'thirdPartyConsensus') {
          return operation[item] ? { key: item, value: Translate.translateHistory(operation[item]) } : { key: item, value: "No" }
        } else {
          return operation[item] ? { key: item, value: Translate.translateHistory(operation[item])} : { key: item, value: "-"}
        }
      }

      )
    },
    formatDuplicate() {
      for (let i = this.history.length - 1; i > 0; i--) {
        const actual = this.history[i]
        const prev = this.history[i - 1]

        prev.filter(item => item.key !== 'source' && item.key !== 'demandType' && item.key !== 'agreementId').forEach((item, index) => {
          if (actual[index].value === prev[index].value) {
            this.history[i][index].value = '-'
          }
        })
      }
    },
    removeDuplicate() {
      this.history.forEach((item, index) => {
        if (item.every(value => value === '-')) {
          this.history.splice(index, 1)
          this.operations.splice(index, 1)
        }
      })
    },
    formatLabels(operation) {
      return Object.keys(operation).filter(item => item !== 'operationDateTime' && item !== 'changeId').map(item => Translate.translateHistory(item))
    },
    formatOperation: operation => {
      operation.gender = operation.gender.substring(0, 1).toUpperCase()

      const birthPlace = operation.birthPlace
      const nation = birthPlace.nation === null ? "ITALIA" : birthPlace.nation
      operation.birthPlace = (nation.toUpperCase() === 'ITALIA') ? `${birthPlace.city} (${birthPlace.province})` : `${nation} (${birthPlace.province})`

      const residence = operation.residence
      operation.residence = `${residence.street} n. ${residence.number} ${residence.city} (${residence.province}) ${residence.nation}`

      if (operation.source === 'Cherry' && (!operation.agreementId || operation.agreementId === 'none')) operation.source = 'DAO Modifica'

      return operation
    },
    asItalianFormat: date => date ? moment(date).format('DD/MM/YYYY HH:mm') : "",
  }
}
</script>

<style>
</style>
